(() => {

    if (window.innerWidth < 990)
        return;

    const template =
        document.querySelector('#custom-mega-menu-template');

    if (!template)
        return;

    let mounted = null;
    let initialized = false;

    function initDropdowns(menu) {

        const items =
            [...menu.querySelectorAll('.has-children')];

        const closeAll = () => {

            items.forEach(item => {

                item.classList.remove('is-open');

                item
                    .querySelector('.cmm__toggle')
                    ?.setAttribute(
                        'aria-expanded',
                        'false'
                    );

            });

        };

        items.forEach(item => {

            const button =
                item.querySelector('.cmm__toggle');

            const link =
                item.querySelector('.cmm__link');

            if (!button || !link)
                return;

            const toggle = e => {

                e.preventDefault();
                e.stopPropagation();

                const opened =
                    item.classList.contains('is-open');

                closeAll();

                if (!opened) {

                    item.classList.add('is-open');

                    button.setAttribute(
                        'aria-expanded',
                        'true'
                    );

                }

            };

            button.addEventListener(
                'click',
                toggle
            );

            link.addEventListener(
                'click',
                toggle
            );

        });

        /* ==========================================
           FECHA AO SAIR DO MENU
        ========================================== */

        menu.addEventListener(
            'mouseleave',
            closeAll
        );

        if (!initialized) {

            document.addEventListener(
                'pointerdown',
                e => {

                    if (e.target.closest('[data-cmm]'))
                        return;

                    closeAll();

                }
            );

            initialized = true;

        }

    }

    function mountMenu() {

        const target =
            document.querySelector('.menu-list__submenu-inner');

        if (!target)
            return;

        if (target.querySelector('[data-cmm]'))
            return;

        mounted =
            template.content
                .firstElementChild
                .cloneNode(true);

        target.replaceChildren(
            mounted
        );

        initDropdowns(mounted);

    }

    const observer =
        new MutationObserver(() => {

            const target =
                document.querySelector('.menu-list__submenu-inner');

            if (!target)
                return;

            if (!target.querySelector('[data-cmm]')) {

                mountMenu();

            }

        });

    observer.observe(
        document.documentElement,
        {
            childList: true,
            subtree: true
        }
    );

    mountMenu();

})();